<template>

    <div id="app" slot="map">

        <!-- 初始化地圖設定 -->
        <l-map
        ref="myMap"
        :zoom="zoom"
        :center="center"
        :options="options"
        :style="calculateAboutMapStyle"
        class="l-map"
        >
        
            <!-- 載入圖資 -->
            <l-tile-layer :url="url" :attribution="attribution" :style="calculateAboutMapStyle" />
            
            <!-- Spa店家所在位置 -->
            <l-marker ref="location" :lat-lng="center">
                <l-icon
                :icon-url="icon.type.red"
                :shadow-url="icon.shadowUrl"
                :icon-size="icon.iconSize"
                :icon-anchor="icon.iconAnchor"
                :popup-anchor="icon.popupAnchor"
                :shadow-size="icon.shadowSize"
                />
                <!-- 彈出視窗 -->
                <l-popup>
                {{ this.selected_merchnt.store_name }}
                </l-popup>
            </l-marker>

            <!-- 創建標記點 -->
            <l-marker :lat-lng="[item.latitude,item.longitude]" v-for="item in resp_data" :key="item.id">

                <!-- 標記點樣式 -->
                <l-icon
                :icon-url="icon.type.parking"
                
                />

                <!-- 彈出視窗 -->
                <l-popup>
                    <a href="http://" target="_blank" rel="noopener noreferrer"></a>
                    {{ item.name }}
                </l-popup>

            </l-marker>

        </l-map>

    </div>

</template>

<script>

// import { apiGetStoreNearbyParkingSpace } from '@/api/Merchant.js'

export default{
    name: 'leaflet-map',
    inject: ["Stores","FilteredStores"],
    props: {
        'leafletMapStyle': {
            type: Object,
            default: () => {
                return {
                    width: "400px",
                    height: "250px"
                }
            }
        }
    },
    data() {
        return {
            google_map_link: '',
            selected_merchnt: this.$parent.$options.propsData.formDataObj,
            // 模擬資料
            // data: [
            //     { id: 1, name: "夢時代購物中心", local: [22.595153, 120.306923] },
            //     { id: 2, name: "漢神百貨", local: [22.61942, 120.296386] },
            //     { id: 3, name: "漢神巨蛋", local: [22.669603, 120.302288] },
            //     { id: 4, name: "大統百貨", local: [22.630748, 120.318033] }
            // ],

            // call Api回來的資料
            resp_data:[],
            zoom: null,
            //center: [22.612961, 120.304167],
            center: [],
            url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
            attribution: `© <a href="http://osm.org/copyright"></a> contributors`,
            options: {
                zoomControl: true
            },
            icon: {
                type: {
                    red: "https://cdn.rawgit.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-red.png",
                    parking: "https://developers.google.com/maps/documentation/javascript/examples/full/images/parking_lot_maps.png"
                },
                shadowUrl:
                "https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png",
                iconSize: [25, 41],
                iconAnchor: [12, 41],
                popupAnchor: [1, -34],
                shadowSize: [41, 41]
            }
        }
    },
    methods: {
        
    },
    mounted() {
        setTimeout(function() { window.dispatchEvent(new Event('resize')) }, 250);
        // 等地圖創建後執行
        // this.$nextTick(() => {
            
        //     console.log(Object.hasOwn(this.$refs.location.mapObject, '_zoom'));
        //     console.log(this.$refs.location.mapObject);
        //     console.log(this.selected_merchnt["map_zoom"]);
        //     console.log(this);
            
        // });
        
    },
    computed: {
        calculateAboutMapStyle() {
            return "height:" + String(this.leafletMapStyle.height) + ";" + "max-width:" + String(this.leafletMapStyle.width) + ";"
        }
    },
    created: async function() {
        this.$bus.$off('changeZoom')
        this.$bus.$on('changeZoom', (zoom) => {
            try {
                if (this.$bus.checkInputValueIsNumber(zoom)) {
                    this.zoom = Number(zoom)
                } else {
                    this.$bus.fnShowInfo("請您輸入1~18之間的數字~")
                }
            } catch (error) {
                console.log(error);
            }
        })
        this.center = [this.selected_merchnt.latitude, this.selected_merchnt.longitude];
        this.zoom = Number(this.selected_merchnt.map_zoom) 
        
        //let aaa = Number(620)
        let req_url = `https://spaapi-j.shopping99.com/api/ticket/reservation/merchant/getMapByStoresId?storesId=${this.selected_merchnt.id}`
        //let req_url = `https://spaapi-staging.shopping99.com/api/ticket/reservation/merchant/getMapByStoresId?storesId=${aaa}`

        const options = {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        } 

        await fetch(req_url, options)
        .then( res => res.json() )
        .then( res_json => {
            console.log('req_url :',req_url);
            console.log(res_json)
            this.resp_data = res_json.data.map
        })
        .catch( error => console.log(error) )

    }
}
</script>

<style scope>
    
</style>